import { render, staticRenderFns } from "./CoreMenu.vue?vue&type=template&id=b112812a&scoped=true"
import script from "./CoreMenu.vue?vue&type=script&lang=js"
export * from "./CoreMenu.vue?vue&type=script&lang=js"
import style0 from "./CoreMenu.vue?vue&type=style&index=0&id=b112812a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b112812a",
  null
  
)

export default component.exports